/**
 * Shared navigation helpers for survey question components.
 * Resolves next_question, next_question_index, and done fallback in one place.
 */

/**
 * Resolve the next question number and optional array index for navigation.
 * Used by Radio, Rating, Checkbox, and TextField to avoid duplicated logic.
 *
 * @param {object} opts
 * @param {object} [opts.question] - Base question (has next_question, next_question_index)
 * @param {object} [opts.activeQuestion] - Active question when different (e.g. conditional target)
 * @param {object} [opts.conditionalConfig] - Config when in conditional flow (has next_question, next_question_index)
 * @param {boolean} [opts.conditional] - Whether we are in a conditional (follow-up) flow
 * @param {array} [opts.survey] - Survey array (for done fallback)
 * @returns {{ nextQuestion: number|null, nextQuestionIndex: number|undefined }}
 */
export function getNextQuestionAndIndex({ question, activeQuestion, conditionalConfig, conditional, survey }) {
    let nextQuestion = (conditional && conditionalConfig && conditionalConfig.next_question)
        || (activeQuestion && activeQuestion.next_question)
        || (question && question.next_question)
        || null;
    const nextQuestionIndex = (conditional && conditionalConfig && conditionalConfig.next_question_index)
        ?? (activeQuestion && activeQuestion.next_question_index)
        ?? (question && question.next_question_index)
        ?? undefined;

    if (nextQuestion === null && conditional && survey) {
        const doneQuestion = survey.find((q) => q.type === 'done');
        if (doneQuestion) {
            nextQuestion = doneQuestion.number;
        }
    }

    return { nextQuestion, nextQuestionIndex };
}
